import { FC } from 'react';

import IconCross from '../icons/cross.svg';
import styles from './chip.module.css';

type Props = {
    label: string
    onRemove: () => void
};

export const Chip: FC<Props> = ({ label, onRemove }) => (
    // eslint-disable-next-line @typescript-eslint/dot-notation
    <span className={styles['chip']}>
        {label}
        <button type="button" className={styles['chip__remove-button']} onClick={onRemove} aria-label="Remove">
            <IconCross />
        </button>
    </span>
);
